import { LanguageCode2 } from '@accedo/one-plugin-sdk';

export enum Languages {
  Default = 'Default',
  Off = 'Off',
  Spanish = 'Spanish',
  French = 'French',
  English = 'English',
  German = 'German',
  Italian = 'Italian',
  Greek = 'Greek',
  Dutch = 'Dutch',
  Swedish = 'Swedish',
  Zulu = 'Zulu',
  Chinese = 'Chinese',
  Zhuang = 'Zhuang',
  Yoruba = 'Yoruba',
  Yiddish = 'Yiddish',
  Xhosa = 'Xhosa',
  Wolof = 'Wolof',
  Walloon = 'Walloon',
  Volapuk = 'Volapuk',
  Vietnamese = 'Vietnamese',
  Venda = 'Venda',
  Uzbek = 'Uzbek',
  Urdu = 'Urdu',
  Ukrainian = 'Ukrainian',
  Uighur = 'Uighur',
  Tahitian = 'Tahitian',
  Twi = 'Twi',
  Tatar = 'Tatar',
  Tsonga = 'Tsonga',
  Turkish = 'Turkish',
  Tonga = 'Tonga',
  Tswana = 'Tswana',
  Tagalog = 'Tagalog',
  Turkmen = 'Turkmen',
  Tigrinya = 'Tigrinya',
  Thai = 'Thai',
  Tajik = 'Tajik',
  Telugu = 'Telugu',
  Tamil = 'Tamil',
  Swahili = 'Swahili',
  Sundanese = 'Sundanese',
  Sotho = 'Sotho',
  Swati = 'Swati',
  Serbian = 'Serbian',
  Albanian = 'Albanian',
  Somali = 'Somali',
  Shona = 'Shona',
  Samoan = 'Samoan',
  Slovenian = 'Slovenian',
  Slovak = 'Slovak',
  Sinhala = 'Sinhala',
  Sango = 'Sango',
  Sami = 'Sami',
  Sindhi = 'Sindhi',
  Sardinian = 'Sardinian',
  Sanskrit = 'Sanskrit',
  Kinyarwanda = 'Kinyarwanda',
  Russian = 'Russian',
  Romanian = 'Romanian',
  Rundi = 'Rundi',
  Romansh = 'Romansh',
  Quechua = 'Quechua',
  Portuguese = 'Portuguese',
  Pushto = 'Pushto',
  Polish = 'Polish',
  Pali = 'Pali',
  Punjabi = 'Punjabi',
  Ossetian = 'Ossetian',
  Oriya = 'Oriya',
  Oromo = 'Oromo',
  Ojibwa = 'Ojibwa',
  Occitan = 'Occitan',
  Chichewa = 'Chichewa',
  Navajo = 'Navajo',
  Norwegian = 'Norwegian',
  Nynorsk = 'Nynorsk',
  Ndonga = 'Ndonga',
  Nepali = 'Nepali',
  Ndebele = 'Ndebele',
  Bokmal = 'Bokmal',
  Nauru = 'Nauru',
  Burmese = 'Burmese',
  Maltese = 'Maltese',
  Malay = 'Malay',
  Marathi = 'Marathi',
  Mongolian = 'Mongolian',
  Malayalam = 'Malayalam',
  Macedonian = 'Macedonian',
  Maori = 'Maori',
  Marshallese = 'Marshallese',
  Malagasy = 'Malagasy',
  Latvian = 'Latvian',
  Lithuanian = 'Lithuanian',
  Lao = 'Lao',
  Lingala = 'Lingala',
  Limburgan = 'Limburgan',
  Ganda = 'Ganda',
  Luxembourgish = 'Luxembourgish',
  Latin = 'Latin',
  Kirghiz = 'Kirghiz',
  Cornish = 'Cornish',
  Komi = 'Komi',
  Kurdish = 'Kurdish',
  Kashmiri = 'Kashmiri',
  Kanuri = 'Kanuri',
  Korean = 'Korean',
  Kannada = 'Kannada',
  Khmer = 'Khmer',
  Kalaallisut = 'Kalaallisut',
  Kazakh = 'Kazakh',
  Kuanyama = 'Kuanyama',
  Kikuyu = 'Kikuyu',
  Kongo = 'Kongo',
  Georgian = 'Georgian',
  Javanese = 'Javanese',
  Japanese = 'Japanese',
  Inuktitut = 'Inuktitut',
  Icelandic = 'Icelandic',
  Ido = 'Ido',
  Inupiaq = 'Inupiaq',
  Igbo = 'Igbo',
  Interlingue = 'Interlingue',
  Indonesian = 'Indonesian',
  Interlingua = 'Interlingua',
  Herero = 'Herero',
  Armenian = 'Armenian',
  Hungarian = 'Hungarian',
  Haitian = 'Haitian',
  Croatian = 'Croatian',
  Hindi = 'Hindi',
  Hebrew = 'Hebrew',
  Hausa = 'Hausa',
  Manx = 'Manx',
  Gujarati = 'Gujarati',
  Guarani = 'Guarani',
  Galician = 'Galician',
  Gaelic = 'Gaelic',
  Irish = 'Irish',
  Frisian = 'Frisian',
  Faroese = 'Faroese',
  Fijian = 'Fijian',
  Finnish = 'Finnish',
  Fulah = 'Fulah',
  Persian = 'Persian',
  Basque = 'Basque',
  Estonian = 'Estonian',
  Esperanto = 'Esperanto',
  Ewe = 'Ewe',
  Dzongkha = 'Dzongkha',
  Maldivian = 'Maldivian',
  Danish = 'Danish',
  Welsh = 'Welsh',
  Chuvash = 'Chuvash',
  Czech = 'Czech',
  Cree = 'Cree',
  Corsican = 'Corsican',
  Chamorro = 'Chamorro',
  Chechen = 'Chechen',
  Catalan = 'Catalan',
  Bosnian = 'Bosnian',
  Breton = 'Breton',
  Tibetan = 'Tibetan',
  Bengali = 'Bengali',
  Bambara = 'Bambara',
  Bislama = 'Bislama',
  Bihari = 'Bihari',
  Bulgarian = 'Bulgarian',
  Belarusian = 'Belarusian',
  Bashkir = 'Bashkir',
  Azerbaijani = 'Azerbaijani',
  Aymara = 'Aymara',
  Avaric = 'Avaric',
  Assamese = 'Assamese',
  Arabic = 'Arabic',
  Aragonese = 'Aragonese',
  Amharic = 'Amharic',
  Akan = 'Akan',
  Afrikaans = 'Afrikaans',
  Avestan = 'Avestan',
  Abkhazian = 'Abkhazian',
  Afar = 'Afar',
}


// We are only support ISO 639-1 language code set at the moment, confirmed with Alexej
export enum LanguagesDesignator {
  default = 'default',
  off = 'off',
  es = 'es',
  fr = 'fr',
  en = 'en',
  de = 'de',
  it = 'it',
  el = 'el',
  nl = 'nl',
  sv = 'sv',
  zu = 'zu',
  zh = 'zh',
  za = 'za',
  yo = 'yo',
  yi = 'yi',
  xh = 'xh',
  wo = 'wo',
  wa = 'wa',
  vo = 'vo',
  vi = 'vi',
  ve = 've',
  uz = 'uz',
  ur = 'ur',
  uk = 'uk',
  ug = 'ug',
  ty = 'ty',
  tw = 'tw',
  tt = 'tt',
  ts = 'ts',
  tr = 'tr',
  to = 'to',
  tn = 'tn',
  tl = 'tl',
  tk = 'tk',
  ti = 'ti',
  th = 'th',
  tg = 'tg',
  te = 'te',
  ta = 'ta',
  sw = 'sw',
  su = 'su',
  st = 'st',
  ss = 'ss',
  sr = 'sr',
  sq = 'sq',
  so = 'so',
  sn = 'sn',
  sm = 'sm',
  sl = 'sl',
  sk = 'sk',
  si = 'si',
  sg = 'sg',
  se = 'se',
  sd = 'sd',
  sc = 'sc',
  sa = 'sa',
  rw = 'rw',
  ru = 'ru',
  ro = 'ro',
  rn = 'rn',
  rm = 'rm',
  qu = 'qu',
  pt = 'pt',
  ps = 'ps',
  pl = 'pl',
  pi = 'pi',
  pa = 'pa',
  os = 'os',
  or = 'or',
  om = 'om',
  oj = 'oj',
  oc = 'oc',
  ny = 'ny',
  nv = 'nv',
  no = 'no',
  nn = 'nn',
  ng = 'ng',
  ne = 'ne',
  nd = 'nd',
  nb = 'nb',
  na = 'na',
  my = 'my',
  mt = 'mt',
  ms = 'ms',
  mr = 'mr',
  mn = 'mn',
  ml = 'ml',
  mk = 'mk',
  mi = 'mi',
  mh = 'mh',
  mg = 'mg',
  lv = 'lv',
  lt = 'lt',
  lo = 'lo',
  ln = 'ln',
  li = 'li',
  lg = 'lg',
  lb = 'lb',
  la = 'la',
  ky = 'ky',
  kw = 'kw',
  kv = 'kv',
  ku = 'ku',
  ks = 'ks',
  kr = 'kr',
  ko = 'ko',
  kn = 'kn',
  km = 'km',
  kl = 'kl',
  kk = 'kk',
  kj = 'kj',
  ki = 'ki',
  kg = 'kg',
  ka = 'ka',
  jv = 'jv',
  ja = 'ja',
  iu = 'iu',
  is = 'is',
  io = 'io',
  ik = 'ik',
  ig = 'ig',
  ie = 'ie',
  id = 'id',
  ia = 'ia',
  hz = 'hz',
  hy = 'hy',
  hu = 'hu',
  ht = 'ht',
  hr = 'hr',
  hi = 'hi',
  he = 'he',
  ha = 'ha',
  gv = 'gv',
  gu = 'gu',
  gn = 'gn',
  gl = 'gl',
  gd = 'gd',
  ga = 'ga',
  fy = 'fy',
  fo = 'fo',
  fj = 'fj',
  fi = 'fi',
  ff = 'ff',
  fa = 'fa',
  eu = 'eu',
  et = 'et',
  eo = 'eo',
  ee = 'ee',
  dz = 'dz',
  dv = 'dv',
  da = 'da',
  cy = 'cy',
  cv = 'cv',
  cs = 'cs',
  cr = 'cr',
  co = 'co',
  ch = 'ch',
  ce = 'ce',
  ca = 'ca',
  bs = 'bs',
  br = 'br',
  bo = 'bo',
  bn = 'bn',
  bm = 'bm',
  bi = 'bi',
  bh = 'bh',
  bg = 'bg',
  be = 'be',
  ba = 'ba',
  az = 'az',
  ay = 'ay',
  av = 'av',
  as = 'as',
  ar = 'ar',
  an = 'an',
  am = 'am',
  ak = 'ak',
  af = 'af',
  ae = 'ae',
  ab = 'ab',
  aa = 'aa',
}

export const LanguageMap: Record<LanguagesDesignator, Languages> = {
  [LanguagesDesignator.default]: Languages.Default,
  [LanguagesDesignator.off]: Languages.Off,
  [LanguagesDesignator.es]: Languages.Spanish,
  [LanguagesDesignator.fr]: Languages.French,
  [LanguagesDesignator.en]: Languages.English,
  [LanguagesDesignator.de]: Languages.German,
  [LanguagesDesignator.it]: Languages.Italian,
  [LanguagesDesignator.el]: Languages.Greek,
  [LanguagesDesignator.nl]: Languages.Dutch,
  [LanguagesDesignator.sv]: Languages.Swedish,
  [LanguagesDesignator.zu]: Languages.Zulu,
  [LanguagesDesignator.zh]: Languages.Chinese,
  [LanguagesDesignator.za]: Languages.Zhuang,
  [LanguagesDesignator.yo]: Languages.Yoruba,
  [LanguagesDesignator.yi]: Languages.Yiddish,
  [LanguagesDesignator.xh]: Languages.Xhosa,
  [LanguagesDesignator.wo]: Languages.Wolof,
  [LanguagesDesignator.wa]: Languages.Walloon,
  [LanguagesDesignator.vo]: Languages.Volapuk,
  [LanguagesDesignator.vi]: Languages.Vietnamese,
  [LanguagesDesignator.ve]: Languages.Venda,
  [LanguagesDesignator.uz]: Languages.Uzbek,
  [LanguagesDesignator.ur]: Languages.Urdu,
  [LanguagesDesignator.uk]: Languages.Ukrainian,
  [LanguagesDesignator.ug]: Languages.Uighur,
  [LanguagesDesignator.ty]: Languages.Tahitian,
  [LanguagesDesignator.tw]: Languages.Twi,
  [LanguagesDesignator.tt]: Languages.Tatar,
  [LanguagesDesignator.ts]: Languages.Tsonga,
  [LanguagesDesignator.tr]: Languages.Turkish,
  [LanguagesDesignator.to]: Languages.Tonga,
  [LanguagesDesignator.tn]: Languages.Tswana,
  [LanguagesDesignator.tl]: Languages.Tagalog,
  [LanguagesDesignator.tk]: Languages.Turkmen,
  [LanguagesDesignator.ti]: Languages.Tigrinya,
  [LanguagesDesignator.th]: Languages.Thai,
  [LanguagesDesignator.tg]: Languages.Tajik,
  [LanguagesDesignator.te]: Languages.Telugu,
  [LanguagesDesignator.ta]: Languages.Tamil,
  [LanguagesDesignator.sw]: Languages.Swahili,
  [LanguagesDesignator.su]: Languages.Sundanese,
  [LanguagesDesignator.st]: Languages.Sotho,
  [LanguagesDesignator.ss]: Languages.Swati,
  [LanguagesDesignator.sr]: Languages.Serbian,
  [LanguagesDesignator.sq]: Languages.Albanian,
  [LanguagesDesignator.so]: Languages.Somali,
  [LanguagesDesignator.sn]: Languages.Shona,
  [LanguagesDesignator.sm]: Languages.Samoan,
  [LanguagesDesignator.sl]: Languages.Slovenian,
  [LanguagesDesignator.sk]: Languages.Slovak,
  [LanguagesDesignator.si]: Languages.Sinhala,
  [LanguagesDesignator.sg]: Languages.Sango,
  [LanguagesDesignator.se]: Languages.Sami,
  [LanguagesDesignator.sd]: Languages.Sindhi,
  [LanguagesDesignator.sc]: Languages.Sardinian,
  [LanguagesDesignator.sa]: Languages.Sanskrit,
  [LanguagesDesignator.rw]: Languages.Kinyarwanda,
  [LanguagesDesignator.ru]: Languages.Russian,
  [LanguagesDesignator.ro]: Languages.Romanian,
  [LanguagesDesignator.rn]: Languages.Rundi,
  [LanguagesDesignator.rm]: Languages.Romansh,
  [LanguagesDesignator.qu]: Languages.Quechua,
  [LanguagesDesignator.pt]: Languages.Portuguese,
  [LanguagesDesignator.ps]: Languages.Pushto,
  [LanguagesDesignator.pl]: Languages.Polish,
  [LanguagesDesignator.pi]: Languages.Pali,
  [LanguagesDesignator.pa]: Languages.Punjabi,
  [LanguagesDesignator.os]: Languages.Ossetian,
  [LanguagesDesignator.or]: Languages.Oriya,
  [LanguagesDesignator.om]: Languages.Oromo,
  [LanguagesDesignator.oj]: Languages.Ojibwa,
  [LanguagesDesignator.oc]: Languages.Occitan,
  [LanguagesDesignator.ny]: Languages.Chichewa,
  [LanguagesDesignator.nv]: Languages.Navajo,
  [LanguagesDesignator.no]: Languages.Norwegian,
  [LanguagesDesignator.nn]: Languages.Nynorsk,
  [LanguagesDesignator.ng]: Languages.Ndonga,
  [LanguagesDesignator.ne]: Languages.Nepali,
  [LanguagesDesignator.nd]: Languages.Ndebele,
  [LanguagesDesignator.nb]: Languages.Bokmal,
  [LanguagesDesignator.na]: Languages.Nauru,
  [LanguagesDesignator.my]: Languages.Burmese,
  [LanguagesDesignator.mt]: Languages.Maltese,
  [LanguagesDesignator.ms]: Languages.Malay,
  [LanguagesDesignator.mr]: Languages.Marathi,
  [LanguagesDesignator.mn]: Languages.Mongolian,
  [LanguagesDesignator.ml]: Languages.Malayalam,
  [LanguagesDesignator.mk]: Languages.Macedonian,
  [LanguagesDesignator.mi]: Languages.Maori,
  [LanguagesDesignator.mh]: Languages.Marshallese,
  [LanguagesDesignator.mg]: Languages.Malagasy,
  [LanguagesDesignator.lv]: Languages.Latvian,
  [LanguagesDesignator.lt]: Languages.Lithuanian,
  [LanguagesDesignator.lo]: Languages.Lao,
  [LanguagesDesignator.ln]: Languages.Lingala,
  [LanguagesDesignator.li]: Languages.Limburgan,
  [LanguagesDesignator.lg]: Languages.Ganda,
  [LanguagesDesignator.lb]: Languages.Luxembourgish,
  [LanguagesDesignator.la]: Languages.Latin,
  [LanguagesDesignator.ky]: Languages.Kirghiz,
  [LanguagesDesignator.kw]: Languages.Cornish,
  [LanguagesDesignator.kv]: Languages.Komi,
  [LanguagesDesignator.ku]: Languages.Kurdish,
  [LanguagesDesignator.ks]: Languages.Kashmiri,
  [LanguagesDesignator.kr]: Languages.Kanuri,
  [LanguagesDesignator.ko]: Languages.Korean,
  [LanguagesDesignator.kn]: Languages.Kannada,
  [LanguagesDesignator.km]: Languages.Khmer,
  [LanguagesDesignator.kl]: Languages.Kalaallisut,
  [LanguagesDesignator.kk]: Languages.Kazakh,
  [LanguagesDesignator.kj]: Languages.Kuanyama,
  [LanguagesDesignator.ki]: Languages.Kikuyu,
  [LanguagesDesignator.kg]: Languages.Kongo,
  [LanguagesDesignator.ka]: Languages.Georgian,
  [LanguagesDesignator.jv]: Languages.Javanese,
  [LanguagesDesignator.ja]: Languages.Japanese,
  [LanguagesDesignator.iu]: Languages.Inuktitut,
  [LanguagesDesignator.is]: Languages.Icelandic,
  [LanguagesDesignator.io]: Languages.Ido,
  [LanguagesDesignator.ik]: Languages.Inupiaq,
  [LanguagesDesignator.ig]: Languages.Igbo,
  [LanguagesDesignator.ie]: Languages.Interlingue,
  [LanguagesDesignator.id]: Languages.Indonesian,
  [LanguagesDesignator.ia]: Languages.Interlingua,
  [LanguagesDesignator.hz]: Languages.Herero,
  [LanguagesDesignator.hy]: Languages.Armenian,
  [LanguagesDesignator.hu]: Languages.Hungarian,
  [LanguagesDesignator.ht]: Languages.Haitian,
  [LanguagesDesignator.hr]: Languages.Croatian,
  [LanguagesDesignator.hi]: Languages.Hindi,
  [LanguagesDesignator.he]: Languages.Hebrew,
  [LanguagesDesignator.ha]: Languages.Hausa,
  [LanguagesDesignator.gv]: Languages.Manx,
  [LanguagesDesignator.gu]: Languages.Gujarati,
  [LanguagesDesignator.gn]: Languages.Guarani,
  [LanguagesDesignator.gl]: Languages.Galician,
  [LanguagesDesignator.gd]: Languages.Gaelic,
  [LanguagesDesignator.ga]: Languages.Irish,
  [LanguagesDesignator.fy]: Languages.Frisian,
  [LanguagesDesignator.fo]: Languages.Faroese,
  [LanguagesDesignator.fj]: Languages.Fijian,
  [LanguagesDesignator.fi]: Languages.Finnish,
  [LanguagesDesignator.ff]: Languages.Fulah,
  [LanguagesDesignator.fa]: Languages.Persian,
  [LanguagesDesignator.eu]: Languages.Basque,
  [LanguagesDesignator.et]: Languages.Estonian,
  [LanguagesDesignator.eo]: Languages.Esperanto,
  [LanguagesDesignator.ee]: Languages.Ewe,
  [LanguagesDesignator.dz]: Languages.Dzongkha,
  [LanguagesDesignator.dv]: Languages.Maldivian,
  [LanguagesDesignator.da]: Languages.Danish,
  [LanguagesDesignator.cy]: Languages.Welsh,
  [LanguagesDesignator.cv]: Languages.Chuvash,
  [LanguagesDesignator.cs]: Languages.Czech,
  [LanguagesDesignator.cr]: Languages.Cree,
  [LanguagesDesignator.co]: Languages.Corsican,
  [LanguagesDesignator.ch]: Languages.Chamorro,
  [LanguagesDesignator.ce]: Languages.Chechen,
  [LanguagesDesignator.ca]: Languages.Catalan,
  [LanguagesDesignator.bs]: Languages.Bosnian,
  [LanguagesDesignator.br]: Languages.Breton,
  [LanguagesDesignator.bo]: Languages.Tibetan,
  [LanguagesDesignator.bn]: Languages.Bengali,
  [LanguagesDesignator.bm]: Languages.Bambara,
  [LanguagesDesignator.bi]: Languages.Bislama,
  [LanguagesDesignator.bh]: Languages.Bihari,
  [LanguagesDesignator.bg]: Languages.Bulgarian,
  [LanguagesDesignator.be]: Languages.Belarusian,
  [LanguagesDesignator.ba]: Languages.Bashkir,
  [LanguagesDesignator.az]: Languages.Azerbaijani,
  [LanguagesDesignator.ay]: Languages.Aymara,
  [LanguagesDesignator.av]: Languages.Avaric,
  [LanguagesDesignator.as]: Languages.Assamese,
  [LanguagesDesignator.ar]: Languages.Arabic,
  [LanguagesDesignator.an]: Languages.Aragonese,
  [LanguagesDesignator.am]: Languages.Amharic,
  [LanguagesDesignator.ak]: Languages.Akan,
  [LanguagesDesignator.af]: Languages.Afrikaans,
  [LanguagesDesignator.ae]: Languages.Avestan,
  [LanguagesDesignator.ab]: Languages.Abkhazian,
  [LanguagesDesignator.aa]: Languages.Afar,
};

export const languageCode2ToLanguage = LanguageMap;

export type LanguageCode2Union = keyof typeof LanguageCode2;
export type LanguagesDesignatorUnion = keyof typeof LanguagesDesignator;
